import React from "react";
import {
  Grid,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  IconButton,
  Dialog,
} from "@mui/material";
import "react-quill/dist/quill.snow.css";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../../globalStyles/fonts";
import { disabledFieldSx } from "../../constants/fieldStyles";

const UserDetailsModal = ({ user, open, onClose }) => {
  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <DialogTitle
            fontSize={"20px"}
            fontFamily={"poppins"}
            fontWeight={500}
            color={"#333333"}
          >
            {"User Details"}
          </DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <Divider style={{ marginBottom: "10px" }} />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <CustomTypography> Name</CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={user?.user?.name || ""}
                InputProps={{
                  readOnly: true,
                }}
                sx={disabledFieldSx}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography fontSize={15}>Email</CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={user?.user?.email || ""}
                InputProps={{
                  readOnly: true,
                }}
                sx={disabledFieldSx}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTypography fontSize={15}>Mobile</CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={user?.user?.phone_no || ""}
                InputProps={{
                  readOnly: true,
                }}
                sx={disabledFieldSx}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: 10 }}>
          <Button
            onClick={onClose}
            variant="outlined"
            style={{ textTransform: "none" }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default UserDetailsModal;
